import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
} from "@angular/core";
import { SocialTemplate } from "src/app/common-container/templates/interface/social";

@Component({
  selector: "app-dynamic-variable",
  templateUrl: "./dynamic-variable.component.html",
  styleUrls: ["./dynamic-variable.component.scss"],
})
export class DynamicVariableComponent implements OnInit {
  @Input() i: number;
  @Input() isValidFormSubmitted: boolean = true;
  @Input() predefinedVariables: any[] = [];
  private _selectedTemplate: SocialTemplate;

  @Input("selectedTemplate")
  set selectedTemplate(value) {
    this._selectedTemplate = value;
  }
  get selectedTemplate() {
    return this._selectedTemplate;
  }
  @Input() dynamicVariables: { [x: string]: { label: string; value: string } } =
    {};
  @Output() public getPreviewContent = new EventEmitter<string>();
  private _content: string;
  @Input()
  set content(value) {
    this._content = value;
  }

  get content() {
    return this._content;
  }
  objectKeys = Object.keys;
  constructor() {}

  ngOnInit() {}
  private getPredefinedVariable(label: string): { value: string } {
    let predefinedVariable = this.predefinedVariables.find(
      (e) => e.label == label
    );
    return {
      value: predefinedVariable?.value || "",
    };
  }
  private postVariable(label: string, post: any) {
    let postVariable = post.dynamic_variables.find(
      (e) => e.variable_name == label
    );
    return postVariable;
  }
  private getPostVariable(label: string, post: any): { value: string } {
    let postVariable = this.postVariable(label, post);
    return {
      value: postVariable?.variable_value || "",
    };
  }

  private templateVariable(label: string) {
    if (this.selectedTemplate !== null) {
      let templateVariable = this.selectedTemplate?.dynamic_variables?.find(
        (e) => {
          return e.variable_name == label;
        }
      );
      return templateVariable;
    }
  }
  private isTemplateVariable(label: string) {
    return this.templateVariable(label);
  }
  private templateVariableArrayLength() {
    let templateVariable: any[] = this.selectedTemplate?.dynamic_variables;
    return templateVariable?.length;
  }
  // private getTemplateVariable(label: string, index: number): { value: string } {
  //   let templateVariable = this.templateVariable(label, index);
  //   return {
  //     value: templateVariable?.variable_value || "",
  //   };
  // }
  private getTemplateVariable(label: string): {
    value: string;
  } {
    let templateVariable = this.templateVariable(label);
    return {
      value: templateVariable?.variable_value || "",
    };
  }
  private getTrimmedVariables(
    dynamicVariablesMatch: string[],
    previewContent: string = null
  ) {
    const curlyBracesTextReg = /{{(.*?)}}/;
    let newPreviewContent: string = previewContent;
    let trimmedVariables = dynamicVariablesMatch.map((variable) => {
      let newVariable = variable.match(curlyBracesTextReg)[1];
      let trimmedLabel = `{{${newVariable.trim()}}}`;
      if (newPreviewContent !== null) {
        newPreviewContent = newPreviewContent.replace(variable, trimmedLabel);
      }
      return trimmedLabel;
    });
    return { trimmedVariables, newPreviewContent };
  }
  public setDynamicVariables(
    contentValue: string,
    editPostData: any | null = null
  ) {
    const curlyBracesReg = /{{(.*?)}}/gi;
    let dynamicVariablesMatch: string[] =
      contentValue.match(curlyBracesReg) || [];
    let { trimmedVariables } = this.getTrimmedVariables(dynamicVariablesMatch);

    if (trimmedVariables.length) {
      let dynamicVariables = trimmedVariables.reduce((variables, label) => {
        let dynamicObj = this.dynamicVariables[label];
        if (dynamicObj) {
          var value = dynamicObj["value"];
        } else {
          var { value } = this.getPredefinedVariable(label);
        }

        if (this.isTemplateVariable(label) !== undefined) {
          var { value } = this.getTemplateVariable(label);
        }
        if (editPostData !== null) {
          var { value } = this.getPostVariable(label, editPostData);
        }
        return {
          ...variables,
          [label]: {
            label,
            value,
          },
        };
      }, {});
      this.dynamicVariables = { ...dynamicVariables };
    } else {
      this.emptyDynamicVariable();
    }
    this.getPreviewContent.emit(this.previewContent(contentValue));
    return this.dynamicVariables;
  }
  onInput() {
    this.updatePreview();
  }
  updatePreview() {
    this.getPreviewContent.emit(this.previewContent(this.content));
  }
  emptyDynamicVariable() {
    this.dynamicVariables = {};
  }
  private filterVariables(isPayload: boolean) {
    const curlyBracesTextReg = /{{(.*?)}}/;
    let dynamicVariables = {};
    let label: string;
    for (const key in this.dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(this.dynamicVariables, key)) {
        const variable = this.dynamicVariables[key];
        if (isPayload) {
          label = variable["label"].match(curlyBracesTextReg)[1];
        } else {
          label = variable["label"];
        }
        let value: string = variable["value"];
        if (label && value) {
          dynamicVariables[label] = value.trim();
        }
      }
    }
    return dynamicVariables;
  }
  createDynamicVariablePayload() {
    let dynamicVariables = this.filterVariables(true);
    return { dynamic_variables: dynamicVariables };
  }
  isInValidDynamicVariable() {
    let isInvalid = false;
    for (const key in this.dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(this.dynamicVariables, key)) {
        const variable = this.dynamicVariables[key];
        if (variable["value"] == "") {
          isInvalid = true;
        }
      }
    }
    return isInvalid;
  }
  private isVariableChanged(dynamicVariables: { [x: string]: any }) {
    let isUpdate = false;
    for (const key in dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(dynamicVariables, key)) {
        const label = key;
        const variableValue = dynamicVariables[key];
        let isTemplateVariable = this.isTemplateVariable(label) !== undefined;
        if (isTemplateVariable) {
          var value = this.getTemplateVariable(label)?.value;
          if (variableValue !== value) {
            isUpdate = true;
          }
        }
      }
    }
    return isUpdate;
  }
  isUpdateDynamicVariable() {
    let isUpdate = false;
    let dynamicVariables = this.filterVariables(false);
    if (this.selectedTemplate !== null) {
      if (
        this.templateVariableArrayLength() !==
          this.objectKeys(dynamicVariables).length ||
        this.isVariableChanged(dynamicVariables)
      ) {
        isUpdate = true;
      }
    }
    return isUpdate;
  }
  private previewDynamicValue(variable: string) {
    let variableValue = this.dynamicVariables[variable]["value"];
    return variableValue || variable;
  }
  public previewContent(contentValue: string) {
    const curlyBracesReg = /{{(.*?)}}/gi;
    let dynamicVariablesMatch: string[] =
      contentValue.match(curlyBracesReg) || [];
    let { trimmedVariables, newPreviewContent } = this.getTrimmedVariables(
      dynamicVariablesMatch,
      contentValue
    );
    trimmedVariables.forEach((variable) => {
      newPreviewContent = newPreviewContent.replace(
        variable,
        this.previewDynamicValue(variable)
      );
    });
    return newPreviewContent;
  }
}
